import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const getErrorMessage = (error: unknown): string => {
    // RTK Query fetch error
    if ((error as FetchBaseQueryError)?.status) {
        const fetchError = error as FetchBaseQueryError;

        // Check if error.data exists and has a message
        if (fetchError.data && typeof fetchError.data === "object" && "message" in fetchError.data) {
        return (fetchError.data as { message: string }).message;
        }

        // fallback to status code
        return `Error ${fetchError.status}`;
    }

    // JS Error object
    if ((error as Error)?.message) {
        return (error as Error).message;
    }

    // fallback
    return "An unexpected error occurred";
};